import EmailFooterV2 from '../components/FooterV2';

// Email Subject: O seu certificado chegou!

interface EmailProps {
  participantName: string
  courseName: string
  completionDate: string
  courseDuration: string
  instructorName: string
  courseId: string
  certificateId: string
  certificateUrl: string
  verificationUrl?: string
  companyName: string
  participantEmail: string
  hoursCompleted: string
  validUntil?: string
  achievementLevel?: string
  supportEmail?: string
  supportPhone?: string
  congratulationsMessage?: string
  linkedinOrgId?: string
  issueYear?: string
  issueMonth?: string
  expirationYear?: string
  expirationMonth?: string
}

export default function CertificateDeliveryEmail({
  participantName = "João Silva",
  courseName = "Fundamentos de Data Analytics",
  completionDate = "15 de abril de 2025",
  courseDuration = "120 minutos",
  instructorName = "Ana Carolina Soares",
  courseId = "FA-2025-001",
  certificateId = "CERT-FA-2025-001-JS",
  certificateUrl = "https://trivium.com.br/certificates/CERT-FA-2025-001-JS",
  verificationUrl = "https://trivium.com.br/verify/CERT-FA-2025-001-JS",
  companyName = "Empresa XYZ Ltda",
  participantEmail = "joao.silva@empresa.com",
  hoursCompleted = "8 horas",
  validUntil = "15 de abril de 2026",
  achievementLevel = "Aprovado com Excelência",
  supportEmail = "atendimento@trivium.com.br",
  supportPhone = "(11) 3181-5940",
  congratulationsMessage = "Parabéns pela conclusão da formação!",
  linkedinOrgId = "10453275",
  issueYear = "2025",
  issueMonth = "4",
  expirationYear,
  expirationMonth,
}: EmailProps) {
  return (
    <div style={{ margin: 0, padding: 0, fontFamily: "Arial, sans-serif", backgroundColor: "#f8f9fa" }}>
      {/* Responsive CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media only screen and (max-width: 600px) {
            .email-container { width: 100% !important; max-width: 100% !important; border-radius: 0 !important; }
            .body-content { padding: 24px 20px !important; }
            .header { padding: 16px !important; }
            .logo { width: 100px !important; }
            .title { font-size: 20px !important; margin: 12px 0 4px !important; }
            .subtitle { font-size: 14px !important; margin: 0 0 20px !important; }
            .badge { font-size: 12px !important; padding: 6px 12px !important; }
            .card { padding: 12px !important; margin-bottom: 6px !important; }
            .card-label { font-size: 11px !important; }
            .card-value { font-size: 14px !important; }
            .section-title { font-size: 16px !important; margin: 20px 0 8px !important; }
            .section-title svg { width: 25px !important; height: 25px !important; }
            .info-box { padding: 16px !important; }
            .info-box h3 { font-size: 15px !important; }
            .info-box p { font-size: 13px !important; }
            .info-list { font-size: 13px !important; }
            .btn { display: block !important; width: 100% !important; text-align: center !important; margin-bottom: 8px !important; }
            .btn-primary { padding: 14px 16px !important; font-size: 15px !important; }
            .list { font-size: 13px !important; padding-left: 16px !important; }
            .contact-box { padding: 16px !important; }
            .contact-title { font-size: 15px !important; }
            .contact-info { font-size: 13px !important; }
            .footer { padding: 20px 16px !important; }
            .footer-logo { width: 70px !important; }
            .social-icons { justify-content: center !important; gap: 20px !important; }
            .social-icon { width: 24px !important; height: 24px !important; }
            .achievement-badge { padding: 12px !important; }
            .certificate-details { padding: 16px !important; }
            .attachment-info { padding: 16px !important; }
            .linkedin-section { padding: 16px !important; }
          }
          @media only screen and (max-width: 480px) {
            .body-content { padding: 20px 16px !important; }
            .title { font-size: 18px !important; }
            .subtitle { font-size: 13px !important; }
            .card { padding: 10px !important; }
            .card-label { font-size: 10px !important; }
            .card-value { font-size: 13px !important; }
            .section-title { font-size: 15px !important; }
            .section-title svg { width: 22px !important; height: 22px !important; }
            .info-box { padding: 14px !important; }
            .btn-primary { padding: 12px 14px !important; font-size: 14px !important; }
            .social-icons { gap: 16px !important; }
            .social-icon { width: 22px !important; height: 22px !important; }
            .achievement-badge { padding: 10px !important; }
            .certificate-details { padding: 14px !important; }
            .attachment-info { padding: 14px !important; }
            .linkedin-section { padding: 14px !important; }
          }
        `
      }} />
      
      <table
        width="100%"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ backgroundColor: "#f8f9fa", padding: "40px 0" }}
      >
        <tbody>
          <tr>
            <td align="center">
              <table
                className="email-container"
                width={600}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                style={{ 
                  backgroundColor: "#ffffff", 
                  borderRadius: "12px", 
                  overflow: "hidden",
                  maxWidth: "600px",
                  margin: "0 auto"
                }}
              >
                <tbody>
                  {/* Header */}
                  <tr>
                    <td 
                      className="header"
                      align="center" 
                      style={{ 
                        backgroundColor: "#1F1746", 
                        padding: "20px",
                        textAlign: "center"
                      }}
                    >
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <img
                          className="logo"
                          src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B"
                          alt="Logo Trivium"
                          width={120}
                          style={{ 
                            display: "block", 
                            width: "120px", 
                            height: "auto",
                            margin: "0 auto"
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  {/* Body */}
                  <tr>
                    <td 
                      className="body-content"
                      style={{ 
                        padding: "36px 30px", 
                        color: "#333333"
                      }}
                    >
                      {/* Badge + Title */}
                      <div style={{ textAlign: "center" }}>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#d9f99d",
                            color: "#365314",
                            display: "inline-block",
                            padding: "8px 16px",
                            borderRadius: "999px",
                            fontSize: "13px",
                            fontWeight: 700,
                            marginBottom: "16px"
                          }}
                        >
                          🎓 Certificado Emitido
                        </span>
                        <h1 
                          className="title"
                          style={{ 
                            fontSize: "24px", 
                            margin: "16px 0 6px", 
                            color: "#111111",
                            lineHeight: "1.3"
                          }}
                        >
                          Parabéns, {participantName}! 🎉
                        </h1>
                        <p 
                          className="subtitle"
                          style={{ 
                            fontSize: "16px", 
                            margin: "0 0 24px", 
                            color: "#555555", 
                            lineHeight: "1.6"
                          }}
                        >
                          {congratulationsMessage}
                        </p>
                      </div>

                      {/* Cards principais - Responsive grid */}
                      <div className="cards-grid" style={{ margin: "6px 0 24px" }}>
                        <table width="100%" cellPadding={0} cellSpacing={0}>
                          <tbody>
                            <tr>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#f9fafb",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    📅 Data de Conclusão
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {completionDate}
                                  </div>
                                </div>
                              </td>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#f9fafb",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    ⏳ Carga Horária
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {hoursCompleted}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#f9fafb",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    👨‍🏫 Instrutor(a)
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {instructorName}
                                  </div>
                                </div>
                              </td>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#f9fafb",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    🏢 Empresa
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {companyName}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>


                      {/* Detalhes do Certificado */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Detalhes do Certificado
                      </h2>
                      <div
                        className="certificate-details"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <h3 style={{ margin: "0 0 4px", fontSize: "16px", color: "#1F1746" }}>{courseName}</h3>
                        <p style={{ margin: "0 0 14px", fontSize: "14px", color: "#6b7280" }}>Certificado ID: {certificateId}</p>
                        <table 
                          width="100%" 
                          cellPadding={0} 
                          cellSpacing={0} 
                          className="info-list"
                          style={{ fontSize: "14px", color: "#111" }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                👤 <strong>Participante:</strong> {participantName}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📅 <strong>Data de Conclusão:</strong> {completionDate}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                ⏳ <strong>Carga Horária:</strong> {hoursCompleted}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                👨‍🏫 <strong>Instrutor:</strong> {instructorName}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🔖 <strong>ID do Certificado:</strong> {certificateId}
                              </td>
                            </tr>
                            {validUntil && (
                              <tr>
                                <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                  📆 <strong>Válido até:</strong> {validUntil}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* Informação sobre Anexo */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Certificado em Anexo
                      </h2>
                      <div
                        className="attachment-info"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <p style={{ margin: "0 0 8px", fontSize: "14px", color: "#111" }}>
                          📎 <strong>Certificado PDF:</strong> Seu certificado oficial está anexado a este email
                        </p>
                        <p style={{ margin: "0", fontSize: "14px", color: "#111" }}>
                          📄 <strong>Como acessar:</strong> Verifique os anexos deste email para baixar o arquivo PDF
                        </p>
                      </div>


                      {/* Compartilhar no LinkedIn */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Compartilhe no LinkedIn
                      </h2>
                      <div
                        className="linkedin-section"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <p style={{ margin: "0 0 16px", fontSize: "14px", color: "#111" }}>
                          💼 <strong>Destaque profissional:</strong> Adicione este certificado ao seu perfil do LinkedIn
                        </p>
                        <div style={{ textAlign: "center" }}>
                          <a
                            href={`https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${encodeURIComponent(courseName)}&organizationId=${linkedinOrgId}&issueYear=${issueYear}&issueMonth=${issueMonth}${expirationYear ? `&expirationYear=${expirationYear}` : ''}${expirationMonth ? `&expirationMonth=${expirationMonth}` : ''}&certId=${encodeURIComponent(certificateId)}&certUrl=${encodeURIComponent(certificateUrl)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#3b65f5",
                              color: "#ffffff",
                              textDecoration: "none",
                              padding: "12px 18px",
                              borderRadius: "8px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              display: "inline-block",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease",
                              maxWidth: "100%",
                              boxSizing: "border-box"
                            }}
                          >
                            📲 Adicionar ao LinkedIn
                          </a>
                        </div>
                      </div>

                      {/* Próximos Passos */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Próximos Passos
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <ul
                          className="list"
                          style={{
                            fontSize: "14px",
                            color: "#4b5563",
                            lineHeight: "1.8",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>📝 Inclua esta formação em seu currículo</li>
                          <li style={{ marginBottom: "8px" }}>🎓 Explore outras formações da Trivium</li>
                          <li style={{ marginBottom: "8px" }}>🌟 Avalie sua experiência conosco</li>
                          <li style={{ marginBottom: "8px" }}>📱 Compartilhe sua conquista em outras redes sociais</li>
                        </ul>
                      </div>

                      {/* Contato de suporte */}
                       <div
                         className="contact-box"
                         style={{
                           backgroundColor: "#f8f9fa",
                           borderRadius: "10px",
                           padding: "18px",
                           margin: "20px 0",
                           textAlign: "center"
                         }}
                       >
                        <h2 
                          className="contact-title"
                          style={{ 
                            fontSize: "16px", 
                            color: "#111", 
                            margin: "0 0 10px"
                          }}
                        >
                          🤝 Precisa de ajuda? Entre em contato conosco:
                        </h2>
                        <p 
                          className="contact-info"
                          style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            color: "#374151", 
                            lineHeight: "1.6"
                          }}
                        >
                          ✉️ {supportEmail}
                          <br />📱 {supportPhone}
                        </p>
                      </div>
                    </td>
                  </tr>

                  {/* Footer */}
                  <tr>
                    <EmailFooterV2 variant="clean" showContactInfo={true} />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
